
const digest = '41af57dfb8f5c0702d98ffcbf262d8301f973649fe116cf90ca03a9c11308ec3';
const classes = {"wrapper":"_wrapper_1bcqi_1","overviewWrapper":"_overviewWrapper_1bcqi_8"};
const css = `._wrapper_1bcqi_1 {
  display: flex;
  font-family: Rubik, "sans-serif";
  flex-direction: column;
  gap: 15px;
}

._overviewWrapper_1bcqi_8 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  